import { i18n } from '@fs/zion-locale'

export default {
  coveragesMarkedCompleteFailedMessage: () =>
    i18n.t('useCoverages.coveragesMarkedCompleteFailedMessage', 'Error marking coverages as complete.'),
  coveragesMarkedCompleteSuccessMessage: () =>
    i18n.t('useCoverages.coveragesMarkedCompleteSuccessMessage', 'Coverages marked as complete.'),
  dateRequiredMessage: () => i18n.t('useCoverages.dateRequiredMessage', 'Each record type requires a date.'),
  dateTooFarFutureMessage: () => i18n.t('useCoverages.dateTooFarFutureMessage', 'Dates cannot be after current year'),
  duplicatePlaceError: () => i18n.t('useCoverages.duplicatePlaceError', 'Place must be unique'),
  duplicateRecordTypeError: () =>
    i18n.t('editableCoverageRecordType.duplicateRecordTypeError', 'Record type already exists'),
  missingPlaceMessage: () => i18n.t('useCoverages.missingPlaceMessage', 'Place must not be empty'),
  placeRequiredMessage: () => i18n.t('useCoverages.placeRequiredMessage', 'At least one place is required'),
  recordTypeRequiredMessage: () =>
    i18n.t('useCoverages.recordTypeRequiredMessage', 'Each place requires a record type.'),
}
